import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuthGuardServicesService } from 'src/app/services/auth-guard-services.service';
import { GetSetAtributosService } from 'src/app/services/get-set-atributos.service';
import { RouterService } from 'src/app/services/router.service';
import { skServices } from 'src/app/services/sk.services.service';
import { StoreService } from 'src/app/services/store.service';
import { UiKitController } from 'src/app/services/uikitcontroller.service';
import { FormProductoPrecioComponent } from '../shared/modal/form-producto-precio/form-producto-precio.component';

@Component({
  selector: 'app-deposito-operador-vendedor',
  templateUrl: './deposito-operador-vendedor.component.html',
  styleUrls: ['./deposito-operador-vendedor.component.scss'],
})
export class DepositoOperadorVendedorComponent implements OnInit {
  vendor:any = [];
  category: any = localStorage.getItem('usuario_categoria');
  currentPage = 1;
  pageOfItems: Array<any>;
  constructor(
    private userControl: AuthGuardServicesService,
    private skservice: skServices,
    private util: UiKitController,
    private router: Router,
    private getSet: GetSetAtributosService,
    private firebaseauthService: AuthGuardServicesService,
    private firestorangeService: StoreService,
    private modalController: ModalController,
    private routerServices: RouterService,
  ) {  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.listarDepControlOperador('1');
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  async listarDepControlOperador(msg:any){
    try {
      var xvalor = {
        cod_prdr:localStorage.getItem('cod_usuario')
      }
      await this.util.loading();
     const response =  await this.skservice.getOperadorVendedorhttp(xvalor).toPromise();
     console.log(response.vendor);
     this.vendor = [...response.vendor];
     if (msg !== null) {
      this.util.ToastSuccess('Store loaded successfull');
    }
    } catch (error) {
      console.log(error);
      
      await this.util.ToastWarning(error.error.message);
    }
  }
  async modalProductoPrecio(xvalor:any){
		try {
        this.getSet.data_vendedor_value = xvalor;
        this.routerServices.rutas_app('operador_almacen_vendedor');

		  /* await this.util.loading();
		  const modal = await this.modalController.create({
			component: FormProductoPrecioComponent,
			cssClass: 'form-pedidos',
			componentProps: { data:xvalor},
			backdropDismiss: false
		  });
		  
		  await modal.present();
		  const { data } = await modal.onWillDismiss();
		  this.listarDepControlOperador();
		  return modal; */
		} catch (error) {
		  console.log(error);
			await this.util.ToastWarning(error.error.message);
		}
		
	  }
    async perfilSeller(xvalor:any){
      try {
        await this.util.loading();
        this.router.navigate(['proveedor',xvalor.cod_usuario]);
        
      } catch (error) {
        console.log(error);
        await this.util.ToastWarning(error.error.message);
      }
      
      }
}
